import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ComparisonSection from './components/ComparisonSection';
import CategoriesSection from './components/CategoriesSection';
import HowItWorks from './components/HowItWorks';
import WhyUs from './components/WhyUs';
import SafetySection from './components/SafetySection';
import ArticlesSection from './components/ArticlesSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import { getOrganizationSchema, getWebPageSchema, getFAQPageSchema } from '@/utils/seoJsonLd';

const organizationSchema = getOrganizationSchema();

const webPageSchema = getWebPageSchema(
  'Kakobuy Spreadsheet Polska 2026 | Najlepsze Kakobuy Finds i Lista Produktów',
  'Odkryj najlepszy Kakobuy Spreadsheet Polska. Aktualne Kakobuy Finds, popularne produkty, poradniki zakupowe i bezpieczne wskazówki dla użytkowników z Polski.',
  'https://kakobuyfinds.fit/',
);

const faqSchema = getFAQPageSchema([
  {
    question: 'Co to jest Kakobuy Spreadsheet?',
    answer: 'Kakobuy Spreadsheet to uporządkowana lista produktów, która pomaga użytkownikom szybciej znaleźć popularne produkty na platformie Kakobuy. Zawiera kategorie takie jak buty, odzież, akcesoria i wiele więcej.',
  },
  {
    question: 'Czy Kakobuy Spreadsheet jest darmowy?',
    answer: 'Tak, nasz Kakobuy Spreadsheet jest całkowicie darmowy. Udostępniamy go społeczności, aby ułatwić wszystkim użytkownikom znajdowanie najlepszych produktów.',
  },
  {
    question: 'Jak często aktualizujecie Spreadsheet?',
    answer: 'Regularnie aktualizujemy nasze listy produktów, dodając nowe kategorie i usuwając nieaktualne pozycje. Ostatnia aktualizacja miała miejsce w 2026 roku.',
  },
  {
    question: 'Czy Kakobuy jest bezpieczny?',
    answer: 'Bezpieczeństwo zależy od sprawdzania produktów, sprzedawców i dokładnej analizy przed zakupem. Nasz Spreadsheet zawiera wskazówki, które pomogą Ci podejmować bezpieczne decyzje zakupowe.',
  },
]);

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ComparisonSection />
        <CategoriesSection />
        <HowItWorks />
        <WhyUs />
        <SafetySection />
        <ArticlesSection />
        <TestimonialSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}